import angular from 'angular';

angular.module('cloudX').directive('bindErrors', function() {
  return {
    restrict: 'A',
    require: 'bindErrors',
    link: function(scope, element, attrs, bindErrors) {
      if (!bindErrors) return; // do nothing if no bindErrors controller
      if (attrs.bindErrors) {
        bindErrors.init(attrs.bindErrors);
      }
    },
    controller: [
      '$scope',
      '$parse',
      function($scope, $parse) {
        var ctrl = this;
        ctrl.$errorTypes = {
          required: {
            code: 3000,
            parameters: [],
          },
          date: {
            code: 16002,
            parameters: [],
          },
        };
        ctrl.$errorBinder = null;
        ctrl.init = function(bindAttr) {
          if (!bindAttr) return;
          ctrl.$errorBinder = $parse(bindAttr);
          ctrl.refreshErrors();
        };

        ctrl.addError = function(type, code, parameters) {
          ctrl.$errorTypes[type] = {
            code: code,
            parameters: parameters || [],
          };
        };

        ctrl.refreshErrors = function(modelErrors) {
          if (!ctrl.$errorBinder) return;
          var errors = {
            $invalid: false,
          };
          if (modelErrors) {
            for (var error in modelErrors) {
              if (modelErrors.hasOwnProperty(error) && error[0] !== '$') {
                if (ctrl.$errorTypes.hasOwnProperty(error))
                  errors[error] = angular.copy(ctrl.$errorTypes[error]);
                errors.$invalid = true;
              }
            }
          }
          ctrl.$errorBinder.assign($scope, errors);
        };
      },
    ],
  };
});
